<template>
  <placeholder-screen title="Manager Access">
    <p class="text-left">
      The only thing better than personal improvement is giving your manager visibility into that process.</p>
    <p class="text-left">
      You’ll be able to grant access to a custom view of your commitment to improvement where we show how long
      you’ve been at it and the length of your streaks (not your actual ratings).  </p>
    <p class="text-left">
      When your manager sees how long you’ve been pursuing excellence and your dedication by keeping at it consistently,
      you’ll stand out from the crowd.  Not only that but, if you choose, you can allow them to tell you what they are
      interested in and you can track that as well.
    </p>
    <p>
      This feature will be available as part of the <em>Act</em> release in December.
    </p>
  </placeholder-screen>
</template>
<script>
  import { mapActions } from 'vuex';
  import PlaceholderScreen from '../UIComponents/PlaceholderScreen.vue'
 
  export default {
    created() {
      this.setNavbarTitle('Manager Access');
    },
    methods: {
      ...mapActions('UI', ['setNavbarTitle']),
    },
    components: {
      PlaceholderScreen
    }
  }

</script>
<style>

</style>
